import { useMemo } from 'react';
import { PENDING_SRC } from '../../constants/pendingSrc';
import { DesktopProductMediaGalleryVariantFragment } from '../../generated/types';
import { DesktopProductMediaGalleryThumbType } from './DesktopProductMediaGallery';

type AlternateImage = NonNullable<
  DesktopProductMediaGalleryVariantFragment['alternateImages'][number]
>;

export const useDesktopProductMediaGalleryImageThumbnails = (images: AlternateImage[]) => {
  const thumbnails = useMemo(
    () =>
      images.map((image, index) => ({
        key: image.medium || `image -- ${index}`,
        src: image.medium || PENDING_SRC,
        large: image.raw,
        type: DesktopProductMediaGalleryThumbType.Image as const
      })),
    [images]
  );

  return thumbnails;
};
